import { render, staticRenderFns } from "./VideoPlayerEight.vue?vue&type=template&id=27350345&"
import script from "./VideoPlayerEight.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerEight.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerEight.vue?vue&type=style&index=0&id=27350345&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports